import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VeeValidate from 'vee-validate'
import Toasted from 'vue-toasted'
import VueTouch from 'vue-touch'
import Popover from 'vue-js-popover'
import './scss/argon/argon.scss'
// import './scss/main.scss'

Vue.config.productionTip = false

Vue.use(VeeValidate)
Vue.use(Toasted as any, {
	duration: 2500,
	position: 'top-center',
	containerClass: 'toast-container',
	action: {
		text: 'Close',
		onClick: (e: any, toastObject: any) => {
			toastObject.goAway(0)
		},
	},
})
Vue.use(VueTouch)
Vue.use(Popover)

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
